import React, { useState } from 'react';
import { motion } from 'framer-motion';
import '../style/ContactForm.css';

const ContactForm = () => {
  const [isSending, setIsSending] = useState(false);
  // "company" es un honeypot: campo oculto para usuarios reales, pero que
  // los bots de spam suelen autocompletar. Si llega con contenido, el
  // backend descarta el envío silenciosamente.
  const [formData, setFormData] = useState({ name: '', email: '', message: '', company: '' });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        alert('¡Mensaje enviado con éxito!');
        setFormData({ name: '', email: '', message: '', company: '' });
      } else if (response.status === 429) {
        alert(data.error || 'Has enviado demasiados mensajes. Intenta de nuevo más tarde.');
      } else if (response.status === 400 && Array.isArray(data.errors)) {
        alert(data.errors.join('\n'));
      } else {
        alert('Hubo un error al enviar el mensaje al servidor.');
      }
    } catch (error) {
      alert('Error de conexión con el servidor.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <motion.form 
      className="contact-form"
      onSubmit={handleSubmit}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
    >
      {/* Honeypot: oculto visualmente y para lectores de pantalla. Nunca lo
          debería completar una persona real. */}
      <input
        type="text"
        name="company"
        value={formData.company}
        onChange={handleChange}
        className="hp-field"
        tabIndex="-1"
        autoComplete="off"
        aria-hidden="true"
      />
      <div className="input-group">
        <input type="text" name="name" value={formData.name} onChange={handleChange} required />
        <label className={formData.name ? "active" : ""}>Tu Nombre</label>
      </div>
      <div className="input-group">
        <input type="email" name="email" value={formData.email} onChange={handleChange} required />
        <label className={formData.email ? "active" : ""}>Correo Electrónico</label>
      </div>
      <div className="input-group">
        <textarea name="message" value={formData.message} onChange={handleChange} required rows="5"></textarea>
        <label className={formData.message ? "active" : ""}>Mensaje</label>
      </div>
      <motion.button 
        type="submit" 
        className="submit-btn"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        disabled={isSending}
      >
        {isSending ? "Enviando..." : "Enviar Mensaje"}
      </motion.button>
    </motion.form>
  );
};

export default ContactForm;